// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"284":"413b83843c409412b45a0c2692fc674f","899":"9ed7b02f130dc0f9edfb77137b2fea5d"}[chunkId] + ".js";
};